import styled from "@emotion/styled";
import Colors from "/styles/colors";
import { GAINSBORO_COLOR_NAME } from "styles/color-consts";
export const StyledHighlightCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 90%;

  .highlight-image {
    width: 100%;
    height: auto;
    overflow: hidden;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
  }

  .highlight-image img {
    width: 100%;
    height: auto;
    object-fit: cover;
  }

  .card-content {
    border: 1px solid ${Colors[GAINSBORO_COLOR_NAME]};
    border-color: ${Colors.gainsboro};
    border-top: none;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    width: calc(100% - 1px);
    padding: 12px;

    .highlight-title {
      font-weight: 600;
      font-size: 1rem;
      padding: 4px 8px 0px;
      text-align: left;
      line-height: 26px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2; /* number of lines to show */
      -webkit-box-orient: vertical;
    }

    .highlight-description {
      font-size: 0.75rem;
      padding: 8px;
      padding-bottom: 0;
      text-align: left;
      line-height: 22px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 4; /* number of lines to show */
      -webkit-box-orient: vertical;
    }

    .button-container {
      display: flex;
      justify-content: left;
      padding: 8px 8px 16px;

      .secondary-button {
        .secondary-button-text {
          font-size: 0.75rem;
        }
      }
    }

    .button-place-holder {
      height: 48px;
    }
  }

  &.is-desktop {
    width: 95%;
    border: 1px solid #dcdfec;
    border-color: ${Colors.gainsboro};
    border-radius: 8px;

    :hover {
      box-shadow: 0 0 16px rgba(29, 140, 242, 0.16);
    }

    .card-content {
      border: none;
      border-color: none;

      .highlight-title {
        -webkit-line-clamp: 1;
      }

      .highlight-description {
        -webkit-line-clamp: 2;
      }
    }
  }
`;
